import React, { useEffect } from 'react';
import Modal from '../../../../Components/Modal/Modal';
import { Button, Input } from '../../../../Components/StyledComponents';
import CreateOption from './CreateOption';
import ReactDragListView from 'react-drag-listview';
import './OptionInfo.scss';
import { Slide } from '@mui/material';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { convertCost, languageText } from '../../../../Utils/functions';
import { alertRef } from '../../../../App';
import ModifyOption from './ModifyOption';

const OptionInfo = () => {
    const [isDrag, setIsDrag] = React.useState(false)
    const [list, setList] = React.useState([])
    const [info, setInfo] = React.useState({});
    const [groupName, setGroupName] = React.useState('');

    const modalRef = React.useRef(null);
    const modalModRef = React.useRef(null);

    const { optionId } = useParams();

    useEffect(() => {
        getOptionInfo()
    }, [])

    const getOptionInfo = () => {
        axios.get('/api/table/order/menu/option/' + optionId)
            .then((data) => {
                setList(data.data.OptionInfo)
                setGroupName(languageText(data.data.Name))
            })
    }

    const dragProps = {
        onDragEnd(fromIndex, toIndex) {
            if (!isDrag) return;
            const data = [...list];
            const item = data.splice(fromIndex, 1)[0];
            data.splice(toIndex, 0, item);
            setList([...data]);
        },
        nodeSelector: 'li',
        handleSelector: 'div',
        lineClassName: 'line',
    };

    const createOption = (val) => {
        axios.post('/api/table/order/menu/option/' + optionId, val)
            .then((data) => {
                if (data.status === 204) {
                    getOptionInfo()
                    modalRef.current.closeModal();
                    alertRef.current.showAlert({ title: '옵션이 생성 되었어요.', isConfirm: true, confirmText: '확인', onConfirm: () => alertRef.current.hideAlert() })
                }
            })
            .catch(() => {
                alertRef.current.showAlert({ title: `다시 시도해 주세요.`, isConfirm: true, confirmText: '확인', onConfirm: () => alertRef.current.hideAlert() })
            })
    }

    const patchOption = (val) => {
        axios.patch('/api/table/order/menu/option/' + optionId, val)
            .then((data) => {
                if (data.status === 204) {
                    getOptionInfo()
                    modalModRef.current.closeModal();
                    alertRef.current.showAlert({ title: '옵션이 수정 되었어요.', isConfirm: true, confirmText: '확인', onConfirm: () => alertRef.current.hideAlert() })
                }
            })
            .catch(() => {
                alertRef.current.showAlert({ title: `다시 시도해 주세요.`, isConfirm: true, confirmText: '확인', onConfirm: () => alertRef.current.hideAlert() })
            })
    }

    const patchOptionOrder = () => {
        let arr = [];
        for (let i = 0; i < list.length; i++) {
            arr.push(list[i]._id.$oid)
        }

        axios.patch('/api/table/order/menu/option/group/re_order', {
            GroupId: optionId,
            OptionIds: arr
        })
            .then((data) => {
                if (data.status === 204) {
                    getOptionInfo()
                    setIsDrag(false)
                    alertRef.current.showAlert({ title: '옵션 순서가 변경 되었어요.', isConfirm: true, confirmText: '확인', onConfirm: () => alertRef.current.hideAlert() })
                }
            })
            .catch(() => {
                alertRef.current.showAlert({ title: `다시 시도해 주세요.`, isConfirm: true, confirmText: '확인', onConfirm: () => alertRef.current.hideAlert() })
            })
    }

    const removeOption = (id) => {
        axios.delete('/api/table/order/menu/option/' + optionId + '/' + id)
            .then((data) => {
                if (data.status === 204) {
                    getOptionInfo()
                    alertRef.current.showAlert({ title: '옵션이 삭제 되었어요.', isConfirm: true, confirmText: '확인', onConfirm: () => alertRef.current.hideAlert() })
                }
            })
            .catch(() => {
                alertRef.current.showAlert({ title: `다시 시도해 주세요.`, isConfirm: true, confirmText: '확인', onConfirm: () => alertRef.current.hideAlert() })
            })
    }

    return (
        <div className='option-info'>
            <div className='header-row between'>
                <div className='row' style={{ cursor: 'pointer' }} onClick={() => window.history.back()}>
                    <img src={require('../../../../aseets/icons/menu-back-arrow.svg').default} style={{ width: 32, height: 32, marginRight: 24 }} />
                    <p className='header' style={{ fontSize: 24 }}>{groupName}</p>
                </div>

                <div className='row'>
                    <Button variant="sub" small style={{ marginRight: 8, width: 112 }} onClick={() => setIsDrag(old => !old)}>
                        {isDrag ? '취소' : '순서변경'}
                    </Button>

                    {
                        isDrag ?
                            <Button variant="main" small style={{ width: 112 }} onClick={() => patchOptionOrder()}>
                                순서 저장
                            </Button>
                            :
                            <Button variant="main" small style={{ width: 112 }} onClick={() => modalRef.current.openModal()}>
                                옵션 추가
                            </Button>
                    }
                </div>
            </div>

            <ReactDragListView {...dragProps}>
                <ol style={{ margin: 0, padding: 0 }}>
                    {
                        list.map((data, i) => {
                            return (
                                <li key={i}>
                                    <div className='divider'></div>
                                    <div className='menu-box'>
                                        <div className='row'>
                                            <Slide direction='right' in={isDrag} mountOnEnter unmountOnExit style={{ transitionDuration: '0.4s', transitionDelay: '0.2s' }}>
                                                <p className='move-icon' style={{ width: isDrag ? 64 : 0, transition: 'all', transitionDuration: '0.2s' }}>
                                                    <div style={{cursor: 'pointer'}}>
                                                        <img src={require('../../../../aseets/icons/menu-drag.svg').default} style={{ width: 24, height: 24, pointerEvents: 'none' }} />
                                                    </div>
                                                </p>
                                            </Slide>
                                            <div style={{ marginLeft: 40 }}>
                                                <p className='menu-name'>{languageText(data.Name)}</p>
                                                <div style={isDrag ? { display: 'none' } : { marginTop: 4 }}>
                                                    <p className='option-price'>{convertCost(data.Price)}원</p>
                                                    <p className='option-desc'>{languageText(data.Description)}</p>
                                                </div>
                                            </div>
                                        </div>

                                        <div className='row' style={{ alignItems: 'center', justifyContent: 'center', height: isDrag ? 0 : 'fit-content', opacity: isDrag ? 0 : 1, transition: 'all', transitionDuration: '0.5s' }}>
                                            <button className='mod-btn' onClick={() => {setInfo(data); modalModRef.current.openModal();}}>
                                                수정하기
                                            </button>
                                            <button className='remove-btn' onClick={() => alertRef.current.showAlert({ title: `정말 옵션을 삭제하시겠어요?`, isConfirm: true, confirmText: '삭제', isCancel: true, cancelText: '취소', onConfirm: () => { alertRef.current.hideAlert(); removeOption(data._id.$oid) } })}>
                                                <img src={require('../../../../aseets/icons/delete.svg').default} style={{ width: 24, height: 24 }} />
                                            </button>
                                        </div>
                                    </div>
                                </li>
                            )
                        })
                    }
                </ol>
            </ReactDragListView>

            <Modal isHeader title='옵션 추가' ref={modalRef} contentContainer={{ width: 500 }} onBackdropClick={null}>
                <CreateOption createOption={createOption} />
            </Modal>

            <Modal isHeader title='옵션 수정' ref={modalModRef} contentContainer={{ width: 500 }} onBackdropClick={null}>
                <ModifyOption patchOption={patchOption} info={info} />
            </Modal>
        </div>
    )
}

export default OptionInfo;